module.exports = __webpack_public_path__ + "static/media/git.5dad0112.png";